<header class="ark-header" [class.header-incident]="incidentActive()">
  <div class="tm-logo">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zM18 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" fill="var(--ark-teal)"/>
    </svg>
    <span class="tm-logo-text">TRUCK<strong>MANAGER</strong></span>
  </div>

  @if (isAuthenticated()) {
    <nav class="ark-nav">
      @if (showRegistration()) {
        <a class="ark-nav-link" routerLink="/registration" routerLinkActive="active">{{ i18n.t()['registration'] }}</a>
      }
      @if (showQueue()) {
        <a class="ark-nav-link" routerLink="/queue" routerLinkActive="active">{{ i18n.t()['queue'] }}</a>
      }
      @if (showPlanning()) {
        <a class="ark-nav-link" routerLink="/planning" routerLinkActive="active">Planning</a>
      }
      @if (showHistory()) {
        <a class="ark-nav-link" routerLink="/history" routerLinkActive="active">{{ i18n.t()['history'] }}</a>
      }
      @if (showViews()) {
        <div class="nav-dropdown" [class.open]="viewsMenuOpen()">
          <button type="button" class="ark-nav-link nav-dropdown-trigger" [class.active]="isViewsActive()" (click)="toggleViewsMenu($event)">
            {{ i18n.t()['views'] || 'Vue' }}
            <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10l5 5 5-5z" fill="currentColor"/></svg>
          </button>
          @if (viewsMenuOpen()) {
            <div class="nav-dropdown-menu">
              <a class="nav-dropdown-item" routerLink="/logistic" routerLinkActive="active" (click)="viewsMenuOpen.set(false)">{{ i18n.t()['viewLogistic'] || 'Logistique' }}</a>
            </div>
          }
        </div>
      }
    </nav>
  }

  <div class="tm-header-right">
    @if (isAuthenticated()) {
      <div class="avatar-wrap">
        <span class="site-badge">{{ effectiveSite() }}</span>
        <button class="avatar-btn" (click)="toggleUserMenu()" [attr.aria-expanded]="userMenuOpen()">
          {{ initials() }}
        </button>
        @if (userMenuOpen()) {
          <div class="avatar-menu">
            <div class="avatar-menu-header">
              <span class="avatar-menu-name">{{ userName() }}</span>
            </div>
            @if (showAnalytics()) {
              <a class="avatar-menu-item" routerLink="/analytics" (click)="userMenuOpen.set(false)">Analytique</a>
            }
            @if (showDashboard()) {
              <a class="avatar-menu-item" routerLink="/dashboard" (click)="userMenuOpen.set(false)">Dashboard</a>
            }
            @if (showSettings()) {
              <a class="avatar-menu-item" routerLink="/settings" (click)="userMenuOpen.set(false)">Paramètres</a>
            }
            @if (isSuperAdmin()) {
              <div class="avatar-menu-divider"></div>
              <div class="avatar-menu-site">
                <span class="avatar-menu-site-label">Changer de site</span>
                <select class="site-select" (change)="switchSite($any($event.target).value)">
                  @for (s of allSites(); track s.code) {
                    <option [value]="s.code" [selected]="s.code === effectiveSite()">{{ s.code }} - {{ s.name }}{{ s.code === auth.currentSite() ? ' (mon site)' : '' }}</option>
                  }
                </select>
              </div>
            }
            <button class="avatar-menu-item avatar-menu-logout" (click)="logout()">Déconnexion</button>
          </div>
        }
      </div>
    }
  </div>
</header>
